import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import useMarkListingAsAvailable from "@/modules/property-tracks/hooks/listings/mark-as-available.hook";

export default function MarkAsAvailableModal({
  open,
  setOpen,
  listingUid,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  listingUid: string;
}) {
  const mutation = useMarkListingAsAvailable();

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    mutation.mutate(listingUid, {
      onSuccess: () => {
        handleModalClose();
        showToast({
          type: ToastType.SUCCESS,
          message: "Listing marked as available successfully",
          toastId: TOAST_IDS.MARK_LISTING_AS_AVAILABLE_SUCCESS,
        });
      },
      onError: (error) => {
        showToast({
          type: ToastType.ERROR,
          message:
            error?.response?.data?.message ||
            "Unexpected error occurred. Please try again.",
          toastId: TOAST_IDS.MARK_LISTING_AS_AVAILABLE_ERROR,
        });
      },
    });
  };
  return (
    <ConfirmationModal
      open={open}
      setOpen={setOpen}
      title="Mark listing as available"
      body="Are you sure you want to mark this listing a available?"
      onConfirmHandler={handleConfirm}
      disableConfirmButton={mutation.isPending}
    />
  );
}
